import TableCell from '@material-ui/core/TableCell';
import PropTypes from 'prop-types';
import React from 'react';

const Cell = (props) => (<TableCell colSpan={props.colSpan || 1} style={{ paddingLeft: 8, paddingRight: 8, overflow: 'hidden', textOverflow: 'ellipsis' }}>{props.children}</TableCell>);

Cell.propTypes = {
  children: PropTypes.any,
};

export default Cell;



// WEBPACK FOOTER //
// ./src/components/Common/Grid/Cell.js